import { Contact } from '@/app/components/Contact';

export function ContactPage() {
  return <Contact />;
}
